import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CalendarDayComponent } from '@finder/features/calendars/components/day/day.component';
import { CalendarFiveDayComponent } from '@finder/features/calendars/components/five-day/five-day.component';
import { CalendarResolver } from '@finder/shared/resolvers/calendar.resolver';
import { CalendarsComponent } from './calendars.component';
import { isParkCalendars } from '@finder/shared/utils/url/isParkCalendarsUrl';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';

const currentPath = new WindowRef().nativeWindow.location.pathname;
const redirectPath = isParkCalendars(currentPath) ? 'five-day' : 'day';

const routes: Routes = [
    {
        path: '',
        component: CalendarsComponent,
        children: [
            {
                path: '',
                redirectTo: redirectPath,
                pathMatch: 'full'
            },
            {
                path: 'day',
                component: CalendarDayComponent,
                data: {
                    viewType: 'day'
                }
            },
            {
                path: 'day/:date',
                component: CalendarDayComponent,
                data: {
                    viewType: 'day'
                },
            },
            {
                path: 'five-day',
                component: CalendarFiveDayComponent,
                data: {
                    viewType: 'five-day'
                }
            },
            {
                path: 'five-day/:date',
                component: CalendarFiveDayComponent,
                data: {
                    viewType: 'five-day'
                },
            },
        ],
        resolve: { calendar: CalendarResolver }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CalendarRoutingModule { }
